import axios from 'axios'

export const API_URL = `https://security.kyrgyzkomur.kg/api/`
// export const API_URL = `https://adv.kyrgyzkomur.kg/api/`

// Глобальный обработчик статуса API
let apiStatusHandler = null;
let wasApiUnavailable = false; // Флаг для отслеживания восстановления связи

export const setApiStatusHandler = (handler) => {
  apiStatusHandler = handler;
};

export const $apiJSON = axios.create({
  withCredentials: true,
  baseURL: API_URL,
})

$apiJSON.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  return config
})

// Interceptor для обработки ошибок
$apiJSON.interceptors.response.use(
  (response) => {
    // Если был показан статус недоступности, убираем его при успешном запросе
    if (apiStatusHandler && wasApiUnavailable) {
      wasApiUnavailable = false; // Сбрасываем флаг
      apiStatusHandler(false);
      // Перезагружаем страницу один раз после восстановления связи
      setTimeout(() => {
        window.location.reload();
      }, 500); // Небольшая задержка для плавного закрытия модального окна
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Проверяем на ошибку 502, 504 или недоступность сервера
    if (error.response?.status === 502 || error.response?.status === 504 || error.code === 'ERR_NETWORK' || !error.response) {
      // Показываем модальное окно
      if (apiStatusHandler) {
        apiStatusHandler(true);
        wasApiUnavailable = true;
      }
      
      // Ждем 5 секунд перед повторной попыткой
      await new Promise(resolve => setTimeout(resolve, 5000));
      
      try {
        // Создаем новый запрос без флага _retry, чтобы цикл продолжался
        const retryConfig = { ...originalRequest };
        delete retryConfig._retry;
        
        const retryResponse = await $apiJSON(retryConfig);
        
        // Если запрос успешен - закрываем модальное окно и перезагружаем страницу
        if (apiStatusHandler && wasApiUnavailable) {
          wasApiUnavailable = false;
          apiStatusHandler(false);
          
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
        
        return retryResponse;
      } catch (retryError) {
        // Если снова ошибка, рекурсивно повторяем
        return Promise.reject(retryError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default $apiJSON
